interface ArrowIconProps {
  color?: string;
}

const ArrowIcon = ({ color = 'black' }: ArrowIconProps) => (
  <svg width='8' height='10' viewBox='0 0 8 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7.36484 4.11953C8.06604 4.4971 8.06604 5.5029 7.36484 5.88047L1.724 8.91784C0.716814 9.46018 -0.264526 8.16004 0.533115 7.34008L2.13121 5.69729C2.50882 5.30911 2.50882 4.69089 2.13121 4.30271L0.533117 2.65992C-0.264525 1.83996 0.716821 0.539826 1.72401 1.08216L7.36484 4.11953Z'
      fill={color}
    />
  </svg>
);

export default ArrowIcon;
